import { render, staticRenderFns } from "./loyalty.vue?vue&type=template&id=35d31fec&"
import script from "./loyalty.vue?vue&type=script&lang=js&"
export * from "./loyalty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports